import type { Tracker, TrackingEvent } from '@archipro-website/tracker';

const PROFESSIONAL_LABEL_EVENT_MAP: Record<string, TrackingEvent> = {
    Overview: 'ProjectNavigationOverviewClick',
    About: 'ProjectNavigationAboutClick',
    Products: 'ProjectNavigationProductsClick',
    Projects: 'ProjectNavigationProjectsClick',
    Articles: 'ProjectNavigationArticlesClick',
    Videos: 'ProjectNavigationVideosClick',
    Network: 'ProjectNavigationNetworkClick',
    Contact: 'ProjectNavigationContactClick',
    'View Profile': 'ProjectNavigationProfileClick',
    ReadMore: 'ProjectNavigationReadMoreClick',
    'Visit Website': 'Website',
};

export const fireProfessionalLinkEvent = (
    label: string,
    url: string,
    tracker: Tracker
) => {
    const event = PROFESSIONAL_LABEL_EVENT_MAP[label];
    if (!event) {
        return;
    }
    tracker.log(event, {
        url: new URL(url),
        targetTracker: 'archiproTracker',
    });
};
